import { forwardRef, type Ref, type SVGProps } from "react";

function SvgLocation(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <path
        stroke="url(#location_svg__a)"
        strokeWidth={8.118}
        d="M64 52.121C64 38.799 74.745 28 88 28s24 10.8 24 24.121c0 8.297-4.056 15.968-8.543 21.953-4.516 6.022-9.674 10.61-12.313 12.786a4.91 4.91 0 0 1-6.288 0c-2.64-2.177-7.797-6.764-12.313-12.786C68.056 68.089 64 60.418 64 52.12Z"
        clipRule="evenodd"
      />
      <path stroke="#0C1C43" strokeWidth={0.812} d="M76 97.594h24" />
      <defs>
        <linearGradient
          id="location_svg__a"
          x1={88}
          x2={88}
          y1={28}
          y2={88}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgLocation);
export default ForwardRef;
